import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const getCustomerDetail = createAsyncThunk(
  "add-order-plan/getCustomerDetail",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-all-customer");
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const getAllMealOnOrder = createAsyncThunk(
  "add-order-plan/getAllMealOnOrder",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-all-meal-on-order");
        // console.log("The res of getting meal from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const verifyOrderStartDate = createAsyncThunk(
  "add-order-plan/verifyOrderStartDate",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/order-start-date-verify", payload);
      // console.log("the response of the order date verify is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const addOrupdateCustomerOrder = createAsyncThunk(
  "add-order-plan/addOrupdateCustomerOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/add-or-update-customer-order",
        payload,
      );
      // console.log("The res of adding order from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.mesage?.data || err.message || err || "Something went wrong",
      );
    }
  },
);

export const addOrupdateDeliverAnOrder = createAsyncThunk(
  "add-order-plan/addOrupdateDeliverAnOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/add-or-update-customer-deliver-an-order",
        payload,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.mesage?.data || err.message || err || "Something went wrong",
      );
    }
  },
);

export const getCustomerDataDeliverAnOrder = createAsyncThunk(
  "add-order-plan/getCustomerDataDeliverAnOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/get-deliver-an-order-detail",
        payload,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const collectPayment = createAsyncThunk(
  "add-order-plan/collectPayment",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/collect-customer-payment",
        payload,
      );
      // console.log("The res of collect pay from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);